export const RESTORE_FOCUS_TIMEOUT=0x64;